import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Login() {
  const [values, setValues] = useState({
    email: "",
    password: ""
  });
  const [showPassword, setShowPassword] = useState(false);

  axios.defaults.withCredentials = true;
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const ValidateEmail = () => {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    return values.email.match(validRegex);
  };
  const navigate = useNavigate();
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!values.email || !values.password) {
        Swal.fire({
          title: 'Please enter all data',
          icon: 'warning',
        });
      } else if (!ValidateEmail()) {
        Swal.fire({
          type: "warning",
          icon: "warning",
          title: "Invalid Email Address",
        });
      } else {
        const res = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/login`, values);

        if (res.status === 200) {
          localStorage.setItem("userData", JSON.stringify(res.data));

          switch (res.data.roll) {
            case "Founder":
              Swal.fire({
                icon: "success",
                title: "Founder Login successfully",
                timer: 1500,
              }).then(() => {
                navigate("/");
              });
              break;
            case "Admin":
              Swal.fire({
                icon: "success",
                title: "Admin Login successfully",
                timer: 1500,
              }).then(() => {
                navigate("/");
              });
              break;
            case "Teacher":
              Swal.fire({
                icon: "success",
                title: "Teacher Login successfully",
                timer: 1500,
              }).then(() => {
                navigate("/");
              });
              break;
            case "Student":
              Swal.fire({
                icon: "success",
                title: "Student Login successfully",
                timer: 1500,
              }).then(() => {
                navigate("/");
              });
              break;
            case "BranchManager":
              Swal.fire({
                icon: "success",
                title: "BranchManager Login successfully",
                timer: 1500,
              }).then(() => {
                const branchId = res.data.data.id_branch;
                localStorage.setItem("branchId", branchId);
                navigate("/");
              });
              break;
            default:
              Swal.fire({
                icon: "success",
                title: `${res.data.Message} Login successfully`,
                timer: 1500,
              }).then(() => {
                navigate("/");
              });
              break;
          }
        } else {
          Swal.fire({
            title: 'Login insertion failed',
            icon: 'error',
          });
        }
      }
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status === 400) {
        if (err.response.data.message === "Invalid email or password") {
          Swal.fire({
            icon: "error",
            title: "Invalid Email or Password",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Invalid Email or Password",
          });
        }
      } else if (err.response.status === 403) {
        Swal.fire({
          icon: "warning",
          title: err.response.data.Message,
        });
      }
    }
  };

  return (
    <>
      <div className="main-wrapper wrapper-login">
        <div className="login-pages">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-12">
                <div className="login-logo">
                  <img src="assets/img/nobel2.png" alt="img" />
                </div>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="col-lg-6 col-xl-5 mx-auto">
                  <div className="login-wrap">
                    <div className="login-content">
                      <div className="login-contenthead text-center">
                        {/* <div className="login-logo">
                        <img src="assets/img/nobel2.png" alt="img" />
                      </div> */}
                        <h5>Login</h5>
                      </div>
                      <div className="login-input">
                        <div className="form-group">
                          <label>E-mail</label>
                          <input
                            type="text"
                            name="email"
                            className="form-control"
                            onChange={handleInputChange}
                            placeholder="Enter Email"
                          />
                        </div>

                        <div className="form-group">
                          <div className="d-flex justify-content-between">
                            <label>Password</label>
                          </div>

                          <div className="pass-group" style={{ position: "relative" }}>
                            <input
                              type={showPassword ? "text" : "password"}   // 👈 Toggle here
                              name="password"
                              className="form-control"
                              onChange={handleInputChange}
                              placeholder="Enter Password"
                            />

                            {/* Show / Hide Icon */}
                            <span
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                fontSize: "14px",
                                color: "#555"
                              }}
                            >
                              {showPassword ? "Hide" : "Show"}
                            </span>
                          </div>
                        </div>

                        {/*
                        <div className="form-group">
                          <div className="d-flex justify-content-between">
                            <label>Password</label>
                          </div>
                          <div className="pass-group">
                            <input
                              type="password"
                              name="password"
                              className="form-control"
                              onChange={handleInputChange}
                              placeholder="Enter Password"
                            />
                          </div>
                        </div>
                        */}
                      </div>
                      <div className="login-button">
                        <button type="submit" className="btn btn-login">Login</button>
                      </div>
                      <div className="text-center" style={{ fontSize: "13px" }}>
                        <a href="/privacy-policy" style={{ color: "#6b9647", fontWeight: 600, textDecoration: "none" }}>Privacy Policy</a>
                        <span style={{ color: "#9c9c9c" }}> · </span>
                        <a href="/terms-and-conditions" style={{ color: "#6b9647", fontWeight: 600, textDecoration: "none" }}>Terms & Conditions</a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
export default Login;